"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.add = exports.createUserInputNeededArtifact = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("./utils"));
const createUserInputNeededArtifact = ({ receivableResponseTapePreview, }) => {
    return {
        id: (0, uuid_1.v4)(),
        type: 'userInputNeeded',
        configuration: {},
        loanProductSlug: null,
        creditFacilitySlug: null,
        artifactDocumentId: receivableResponseTapePreview.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `userInputNeeded_${receivableResponseTapePreview.artifactSlug}`,
    };
};
exports.createUserInputNeededArtifact = createUserInputNeededArtifact;
// create a synthetic node userInputNeeded which goes between
// receivableResponseTapePreview => userInputNeeded => assignedLoanTape.
//
// for each artifact of type "receivableResponseTapePreview"
//  1. create a new artifact of type "userInputNeeded"
//  2. create a new dependency between receivableResponseTapePreview => userInputNeeded
//  3. find all assignedLoanTape corresponding to receivableResponseTapePreview
//    a. for this we look at the LP slug of the masterLoanTapes preceding the receivableResponseTapePreview
//    b. find all assignedLoanTapes matching the LPSlug
//           create a new dependency between userInputNeeded => assignedLoanTape
//
const add = (dbGraph) => {
    const rrtPreviews = utils.filterReceivableResponseTapePreviews(dbGraph);
    const assignedLoanTapes = utils.filterAssignedLoanTapes(dbGraph);
    const newDependencies = [];
    const newArtifacts = [];
    rrtPreviews.forEach((rrtPreview) => {
        const userInputNeeded = (0, exports.createUserInputNeededArtifact)({
            receivableResponseTapePreview: rrtPreview,
        });
        newArtifacts.push(userInputNeeded);
        newDependencies.push({
            inputArtifactId: rrtPreview.id,
            outputArtifactId: userInputNeeded.id,
        });
        const masterLoanTapes = utils.getInputTapes({
            dbGraph,
            outputArtifactId: rrtPreview.id,
        });
        // find input tapes.
        masterLoanTapes.forEach((masterLoanTape) => {
            (0, common_1.finleyAssert)(masterLoanTape.type === 'masterLoanTape', `Unexpected type for masterLoanTape: ${masterLoanTape.type}`);
            (0, common_1.finleyAssert)(masterLoanTape.loanProductSlug, 'Expected masterLoanTape.loanProductSlug');
            // find all assignedLoanTapes that match the cfSlug for this masterLoanTape.
            const assignedLoanTapesForMasterLoanTape = assignedLoanTapes.filter((alt) => alt.loanProductSlug === masterLoanTape.loanProductSlug);
            assignedLoanTapesForMasterLoanTape.forEach((assignedLoanTape) => {
                newDependencies.push({
                    inputArtifactId: userInputNeeded.id,
                    outputArtifactId: assignedLoanTape.id,
                });
            });
        });
    });
    return {
        dataTapes: [...dbGraph.dataTapes, ...newArtifacts],
        dataTapeDependencies: [...dbGraph.dataTapeDependencies, ...newDependencies],
    };
};
exports.add = add;
// remove all the userInputNeededNodes (for assginemnt) and their dependencies.
const remove = (dbGraph) => {
    const userInputNeededNodeIds = utils
        .filterUserInputNeededNodesForAssignment(dbGraph)
        .map(({ id }) => id);
    // filter out userInputNeededNodes and their dependencies.
    const dataTapes = dbGraph.dataTapes.filter((dataTape) => !userInputNeededNodeIds.includes(dataTape.id));
    const dataTapeDependencies = dbGraph.dataTapeDependencies.filter((dataTapeDependency) => !userInputNeededNodeIds.includes(dataTapeDependency.inputArtifactId) &&
        !userInputNeededNodeIds.includes(dataTapeDependency.outputArtifactId));
    return {
        dataTapeDependencies,
        dataTapes,
    };
};
exports.remove = remove;
//# sourceMappingURL=assignmentUserInput.js.map